import React, { useState, useEffect, useRef } from 'react'
import styled from 'styled-components'
import useLocalStorage from '../../hooks/useLocalStorage'

const SCALE = 12
const DURATION = 2

const Circle = styled.div`
    pointer-events: none;
    position: relative;
    z-index: 3;
    opacity: 0;
    position: absolute;
    width: 5px;
    height: 5px;
    border: 1px solid ${props => props.color || 'red'};
    border-radius: 150%;
    transition-property: opacity, transform;
    transition-duration: ${DURATION}s;

    &.fade-grow-enter, &.fade-grow-appear {
        opacity: 1;
    }

    &.fade-grow-enter-active, &.fade-grow-appear-active {
        opacity: 0;
        transform: scale(${SCALE});
    }

    &.fade-grow-enter-done, &.fade-grow-appear-done {
        transform: scale(${SCALE});
        opacity: 0;
    }
`

const Ping = ({ onDestroy }) => {
    const [settings] = useLocalStorage()
    const { color } = settings

    useEffect(() => {
        const timeoutId = window.setTimeout(() => {
            onDestroy()
        }, (DURATION * 1000) - 200)
        return () => {
            window.clearTimeout(timeoutId)
        }
    }, [])

    return (
        <Circle color={color} />
    )
}

export default Ping
